import "./InsetTabs.Component.scss";

type InsetTabsItem = { id: string; label: React.ReactNode | string; badge: boolean };
interface Props {
  items: InsetTabsItem[];
  selectedItem?: string;
  itemSelected: (id: string) => void;
}

export function InsetTabsComponent(props: Props) {
  return (
    <div className={`InsetTabsComponent`}>
      {props.items.map((item, index) => (
        <InsetTabsComponentItem key={index} itemSelected={props.itemSelected} selectedItem={props.selectedItem} item={item} />
      ))}
    </div>
  );
}

interface ItemProps {
  item: InsetTabsItem;
  selectedItem?: string;
  itemSelected: (id: string) => void;
}

function InsetTabsComponentItem(props: ItemProps) {
  const { item, selectedItem, itemSelected } = props;

  return (
    <div onClick={() => itemSelected(item.id)} className={`InsetTabsComponentItem ${item.id === selectedItem ? "selected" : ""}`}>
      {item.label}
      {item.badge && <div className="InsetTabsComponentItemBadge" />}
    </div>
  );
}
